<ng-container *ngIf="loading">
  <div class="loading-bar">
      <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
</div>
</ng-container>

 <div class="topborderButton">
    <tm1-button routerLink="/tools/barcodehistory"> Barcode History </tm1-button>
    <tm1-button *ngIf="isTicketmaster" routerLink="/tools/gates">Gate Set Up</tm1-button>
    <tm1-button routerLink="/tools/scanner">Scanner</tm1-button>
</div>
<br/>
<div class="container">
    <div class="card-container">
      <tm1-card variant = "shadow">
            <legend>
              Barcode History
              <tm1-icon-tooltip icon="info" size="small" color="blue">
                Scan window must be active for barcode history to appear
              </tm1-icon-tooltip>
            </legend>

            <tm1-label>Venue</tm1-label>
            <select class="form-control" [(ngModel)]="Selectedvenue" (change) = "onVenueChange()">
                <option value="">Please Select a Venue</option>
                <option *ngFor="let venue of venuelist" [value]="venue.key">
                  {{ venue.value.name }}
                </option>
              </select>
            <br />
            <div>
              <tm1-text-field ngDefaultControl ="barcode"  (change)="onBarcodeChange($event)" style="width: 20%;" appearance="filled"
              inputsize="regular"  labelposition="" minlengtherror="" patternerror="" error="" maxlength="20" minlength="2"
              placeholder="Barcode" size="20" type="text" value="{{barcode}}" charactercountlabel="character(s) left"></tm1-text-field>
            <br />
            <tm1-button variant="solid" style="width: max-content" (click)="getBarcodeHistory($event)">
              Check History
            </tm1-button>
            </div>
      </tm1-card>
    </div>

    <ng-container *ngIf="historySummary !== ''">
        <div class="container">
          <div class="table-container">
            <tm1-card>
              <tm1-data-grid class="tm1-data-grid" generate-header="" focus-column-index="0" focus-row-index="0">
                <tm1-data-grid-row row-type="sticky-header" class="tm1-data-grid-row">
                  <tm1-data-grid-cell grid-column="1" cell-type="columnheader">
                    Scan Time
                  </tm1-data-grid-cell>
                  <tm1-data-grid-cell grid-column="2" cell-type="columnheader">
                    Device Name
                  </tm1-data-grid-cell>
                  <tm1-data-grid-cell grid-column="3" cell-type="columnheader">
                    Gate Name
                  </tm1-data-grid-cell>
                  <tm1-data-grid-cell grid-column="4" cell-type="columnheader">
                    Section
                  </tm1-data-grid-cell>
                  <tm1-data-grid-cell grid-column="5" cell-type="columnheader">
                    Row
                  </tm1-data-grid-cell>
                  <tm1-data-grid-cell grid-column="6" cell-type="columnheader">
                    Seat
                  </tm1-data-grid-cell>
                  <tm1-data-grid-cell grid-column="7" cell-type="columnheader">
                    Result
                  </tm1-data-grid-cell>
                  <tm1-data-grid-cell grid-column="8" cell-type="columnheader">
                    Event ID
                  </tm1-data-grid-cell>
                </tm1-data-grid-row>

                <tm1-data-grid-row>
                  <ng-container *ngFor="let history of historySummary">
                    <tm1-data-grid-cell grid-column="1">
                      {{ history.scanTimeInstant | epochToLocalTime }}
                    </tm1-data-grid-cell>
                    <tm1-data-grid-cell grid-column="2">
                      {{ history.deviceName }}
                    </tm1-data-grid-cell>
                    <tm1-data-grid-cell grid-column="3">
                      {{ history.gateName }}
                    </tm1-data-grid-cell>
                    <tm1-data-grid-cell grid-column="4">
                      {{ history.section }}
                    </tm1-data-grid-cell>
                    <tm1-data-grid-cell grid-column="5">
                      {{ history.row }}
                    </tm1-data-grid-cell>
                    <tm1-data-grid-cell grid-column="6">
                      {{ history.seat }}
                    </tm1-data-grid-cell>
                    <tm1-data-grid-cell grid-column="7">
                      {{ history.scanResult }}
                    </tm1-data-grid-cell>
                    <tm1-data-grid-cell grid-column="8">
                      {{ history.eventId }}
                    </tm1-data-grid-cell>
                  </ng-container>
                </tm1-data-grid-row>
              </tm1-data-grid>
            </tm1-card>
          </div>
        </div>
      </ng-container>

  </div>
       